import { formatAmountWithCommas } from "@unified-checkout/design-system";

export const formatAmount = (amount: number, currency: string, lang: string) => {
  const formattedAmount = formatAmountWithCommas({ amount, currency});
  return lang === 'en'
    ? `${currency} ${formattedAmount}`
    : `${formattedAmount} ${currency}`;
};

export const renderBalance = (balance: number | null | undefined, currency: string, lang: string) => {
    if (typeof balance === 'number') {
      return formatAmount(balance, currency, lang);
    }
    return '-';
  };